import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useLocation } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  Card,
  CardGroup,
  CardBody,
  CardHeader,
  CardHeaderBtn,
} from "./../../components/card/card.jsx";
import Swal from "sweetalert2";
import { Circles } from "react-loader-spinner";
import "moment/locale/es";
import Select from "react-select";

const construirNombreCompleto = (cliente = {}) => {
  return [
    cliente?.nombre,
    cliente?.apellido_paterno ?? cliente?.apellidoPaterno,
    cliente?.apellido_materno ?? cliente?.apellidoMaterno,
  ]
    .map((valor) => String(valor || "").trim())
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
};

const customStyles = {
  control: (base) => ({
    ...base,
    borderColor: "transparent",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: "0",
    color: "white",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#fff",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    color: "black", // Text color for options
    backgroundColor: state.isFocused ? "transparent" : "transparent",
    "&:active": {
      backgroundColor: "transparent",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "white", // Color of the selected value
  }),
  input: (base) => ({
    ...base,
    color: "white", // Color of the input text
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the dropdown indicator to white
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the clear indicator to white
  }),
};

function VentasTotales() {
  // Obtener los módulos desde localStorage
  const modules = JSON.parse(localStorage.getItem("modulos")) || [];

  // Obtener la ubicación actual
  const location = useLocation();

  // Definir los tabs con su nombre, URL y módulo correspondiente
  const tabs = [
    { name: "Crear Venta", to: "/form/crear-venta", module: "form-wizards" },
    { name: "Ventas", to: "/form/ventas", module: "form-wizards" },
  ];

  const [mailData, setMailData] = useState([]);
  const [loading, setLoading] = useState(false); // Estado para el loader
  const [selectedMailData, setSelectedMailData] = useState(null);

  const [filters, setFilters] = useState({
    asesor: "",
    telefono: "",
    agencia: "",
    tipo_auto: "",
    nombre: "",
  });

  const [filterOptions, setFilterOptions] = useState({
    asesor: [],
    telefono: [],
    agencia: [],
    tipo_auto: [],
    nombre: [],
    startDate: "",
    endDate: "",
  });

  const segurosPorAuto = {
    "Renault Kwid Bitono TM": {
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$9,780.55",
    },
    "Renault Kwid Iconic TM": {
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$9,612.28",
    },
    "Renault Kwid Intens TM": {
      //precio correcto
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$9,331.14",
    },
    "Renault Kwid E-Tech": {
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$12,344.67",
    },
    "Renault Logan Intens TM": {
      //pendiente
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$9,331.14",
    },
    "Renault Logan Intens CVT": {
      //pendiente
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$9,331.14",
    },
    "Renault STEPWAY Intens TM": {
      //pendiente
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$9,331.14",
    },
    "Renault STEPWAY Intens CVT": {
      //pendiente
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$9,331.14",
    },
    "Renault Duster Iconic CVT": {
      Aseguradora: "Zurich",
      PrimaTotal: "$12,221.46",
    },
    "Renault Duster Intens TM": {
      Aseguradora: "Qúalitas Compañia De Seguros",
      PrimaTotal: "$9,639.23",
    },
    "Renault Oroch Zen TM": {
      Aseguradora: "Zurich Aseguradora Mexicana SA de CV",
      PrimaTotal: "$16,025.53",
    },
    "Renault Oroch Outsider TM": {
      Aseguradora: "CHUBB",
      PrimaTotal: "$15,099.78",
    },
    "Renault Oroch Outsider CVT": {
      Aseguradora: "CHUBB",
      PrimaTotal: "$16,250.43",
    },
    "Renault Koleos Intens CVT": {
      Aseguradora: "CHUBB",
      PrimaTotal: "$16,250.43",
    },
    "Renault Koleos Iconic CVT": {
      Aseguradora: "CHUBB",
      PrimaTotal: "$15,096.73",
    },
    "Renault Kangoo Intens": {
      Aseguradora: "Zurich",
      PrimaTotal: "$11,772.14",
    },
    "Renault Kangoo E-Tech": {
      Aseguradora: "Qúalitas Compañia De Seguros",
      PrimaTotal: "$33,981.64",
    },
    "Renault Master Diesel L2H2": {
      Aseguradora: "Qúalitas Compañia De Seguros",
      PrimaTotal: "$31,854.17",
    },
    "Renault Master Diesel L3H2": {
      Aseguradora: "CHUBB",
      PrimaTotal: "$22,402.29",
    },
    "Renault Master E-Tech": {
      Aseguradora: "Qúalitas Compañia De Seguros",
      PrimaTotal: "$84,378.86",
    },
  };

  // Función para buscar el seguro
  const getSeguroPorAuto = (selectedMailData, segurosPorAuto) => {
    const marca = selectedMailData?.marca_vehiculo?.trim() || "";
    const modelo = selectedMailData?.modelo_vehiculo?.trim() || "";
    const version = selectedMailData?.version_vehiculo?.trim() || "";

    // Claves normalizadas
    const claveConModelo = `${marca} ${modelo} ${version}`
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

    const claveSinModelo = `${marca} ${version}`
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

    // Normalizar las claves de segurosPorAuto
    const segurosPorAutoNormalizado = Object.keys(segurosPorAuto).reduce(
      (acc, key) => {
        acc[key.toLowerCase()] = segurosPorAuto[key];
        return acc;
      },
      {},
    );

    // Buscar el seguro (con modelo primero, sin modelo como fallback)
    const seguro =
      segurosPorAutoNormalizado[claveConModelo] ||
      segurosPorAutoNormalizado[claveSinModelo] ||
      null;

    if (!seguro) return null;

    // Devolver en el formato que necesitas (title, price)
    return {
      title: seguro.Aseguradora,
      price: parseFloat(seguro.PrimaTotal.replace(/[$,]/g, "")), // convertir "$9,780.55" en 9780.55
    };
  };

  const [userModules, setUserModules] = useState(
    JSON.parse(localStorage.getItem("modulos")) || [],
  );
  const isAdmin = userModules.includes("admin");

  const userId = localStorage.getItem("userId");

  const accessToken =
    "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso
  const apiUrl = "https://api.checkmark.mx/ventas/consultar"; // La URL de la API
  // Función para obtener los datos desde la API
  const fetchData = async () => {
    setLoading(true); // Activar el loader

    try {
      const agenciasStorage = JSON.parse(localStorage.getItem("agencias")); // Recuperar agencias del localStorage
      const modulos = JSON.parse(localStorage.getItem("modulos")); // Recuperar los módulos del localStorage
      const userId = localStorage.getItem("userId"); // Obtener el userId desde el localStorage

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
          modulos, // Envía los módulos
          usuario_id: userId, // Envía el user_id
          agencias: agenciasStorage, // Envía las agencias
          // Otros filtros
          ...filters,
        }),
      });

      const data = await response.json();
      console.log("Respuesta de la API:", data); // Log para depuración

      if (data.statusCode === 200) {
        // Verifica si hay resultados y asigna correctamente a mailData
        if (
          Array.isArray(data.data.resultados) &&
          data.data.resultados.length > 0
        ) {
          // Procesar los datos
          const processedData = data.data.resultados.map((cliente) => {
            let productos = [];

            if (
              cliente.planes_seleccionados &&
              cliente.planes_seleccionados !== '"null"'
            ) {
              let accesorioString;

              try {
                // Intentamos parsear la primera vez
                accesorioString = JSON.parse(cliente.planes_seleccionados);
              } catch {
                // Si falla, asumimos que no es un JSON válido y lo dejamos como está
                accesorioString = cliente.planes_seleccionados;
              }

              // Verificamos si el resultado puede ser un string JSON anidado
              if (typeof accesorioString === "string") {
                try {
                  // Intentamos parsear nuevamente si es necesario
                  accesorioString = JSON.parse(accesorioString);
                } catch {
                  // Si falla, dejamos el accesorio como un array vacío para evitar errores
                  accesorioString = [];
                }
              }

              // Convertimos a array si no lo es ya
              productos = Array.isArray(accesorioString)
                ? accesorioString
                : [accesorioString];
            }

            return {
              ...cliente,
              nombre_completo: construirNombreCompleto(cliente),
              productos, // Añadir los productos procesados al cliente
            };
          });

          setMailData(processedData);
        } else {
          console.error("No hay registros disponibles.");
          // No hay resultados, se asigna un arreglo vacío
          setMailData([]);
          setSelectedMailData(null);

          Swal.fire({
            icon: "warning",
            title: "Sin resultados",
            text: "No se encontraron resultados para los filtros aplicados.",
          });
        }
      } else if (data.statusCode === 404) {
        // No hay resultados, se asigna un arreglo vacío
        setMailData([]);
        setSelectedMailData(null);
        // Mostrar alerta si el statusCode es 404
        Swal.fire({
          icon: "warning",
          title: "Sin resultados",
          text: "No se encontraron resultados para los filtros aplicados.",
        });
      } else {
        // No hay resultados, se asigna un arreglo vacío
        setMailData([]);
        setSelectedMailData(null);
        console.error(
          "Error al obtener los datos:",
          data.message || "Sin mensaje de error.",
        );
      }
    } catch (error) {
      // No hay resultados, se asigna un arreglo vacío
      setMailData([]);
      setSelectedMailData(null);
      console.error("Error en la solicitud:", error);
    } finally {
      setLoading(false); // Desactivar el loader una vez que se termine la solicitud
    }
  };

  const fetchFilterOptions = async () => {
    setLoading(true); // Activar el loader

    try {
      const agenciasStorage = JSON.parse(localStorage.getItem("agencias")); // Recuperar agencias del localStorage
      const modulos = JSON.parse(localStorage.getItem("modulos")); // Recuperar los módulos del localStorage
      const userId = localStorage.getItem("userId"); // Obtener el userId desde el localStorage

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
          modulos, // Envía los módulos
          usuario_id: userId, // Envía el user_id
          agencias: agenciasStorage, // Envía las agencias
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        const { opciones } = data.data;
        if (opciones && Object.keys(opciones).length > 0) {
          setFilterOptions(opciones);
        } else {
          // Si no hay opciones disponibles, mostrar alerta
          Swal.fire({
            icon: "warning",
            title: "Sin opciones",
            text: "No se encontraron opciones para los filtros.",
          });
        }
      } else if (data.statusCode === 404) {
        // Si el statusCode es 404, mostrar alerta de "sin resultados"
        Swal.fire({
          icon: "warning",
          title: "Sin resultados",
          text: "No se encontraron opciones para los filtros.",
        });
      } else {
        console.error(
          "Error al obtener las opciones de filtro:",
          data.message || "Sin mensaje de error.",
        );
      }
    } catch (error) {
      console.error("Error al obtener las opciones de filtro:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener las opciones de filtro.",
      });
    } finally {
      setLoading(false); // Desactivar el loader una vez que termine la solicitud
    }
  };

  // Llama a `fetchData` y `fetchFilterOptions` cuando se monte el componente
  useEffect(() => {
    fetchData();
    fetchFilterOptions();
  }, [filters]); // Llamar a fetchData cuando los filtros cambian

  const handleDateApplyEvent = (event, picker) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: picker.startDate.format("YYYY-MM-DD"),
      endDate: picker.endDate.format("YYYY-MM-DD"),
    }));
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const cancelButton = document.querySelector(".cancelBtn");
      const applyButton = document.querySelector(".applyBtn");

      // Solo cambiar el texto si no es el valor correcto
      if (cancelButton && cancelButton.textContent !== "Cancelar") {
        cancelButton.textContent = "Cancelar";
      }
      if (applyButton && applyButton.textContent !== "Aplicar") {
        applyButton.textContent = "Aplicar";
      }
    });

    const targetNode = document.body;
    observer.observe(targetNode, { childList: true, subtree: true });

    return () => observer.disconnect(); // Limpiar observador al desmontar
  }, []);

  useEffect(() => {
    if (mailData.length > 0 && selectedMailData) {
      const updatedClient = mailData.find(
        (cliente) => cliente.id === selectedMailData.id,
      );
      setSelectedMailData(updatedClient || null);
    }
  }, [mailData]);

  function toTitleCase(str) {
    return str
      .toLowerCase()
      .replace(/(?:^|\s|\/|-)\S/g, (match) => match.toUpperCase());
  }

  useEffect(() => {
    console.log("selectedMailData actualizado:", selectedMailData);
  }, [selectedMailData]);

  // Extraer el seguro
  const seguro = getSeguroPorAuto(selectedMailData, segurosPorAuto);

  return (
    <div>
      {loading ? (
        <div className="loader-data">
          <Circles height="80" width="80" color="#4fa94d" />
        </div>
      ) : (
        <div>
          <div className="mailbox">
            <div className="mailbox-toolbar">
              {tabs.map((tab) =>
                modules.includes(tab.module) ? (
                  <div className="mailbox-toolbar-item" key={tab.name}>
                    <Link
                      to={tab.to}
                      className={`mailbox-toolbar-link ${
                        location.pathname === tab.to ? "active" : ""
                      }`}
                    >
                      {tab.name}
                    </Link>
                  </div>
                ) : null,
              )}
            </div>
            <div className="d-flex align-items-center mb-3 mt-3">
              <DateRangePicker
                startDate={filters.startDate}
                endDate={filters.endDate}
                onApply={handleDateApplyEvent}
              >
                <a
                  href="#/"
                  className="btn btn-secondary btn-sm d-inline-flex align-items-center"
                >
                  <span>
                    {filters.startDate && filters.endDate
                      ? `${filters.startDate} - ${filters.endDate}`
                      : "Selecciona un rango"}
                  </span>
                  <i className="fa fa-chevron-down ms-2 fs-8px"></i>
                </a>
              </DateRangePicker>
            </div>

            <div className="row">
              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar cliente", value: "" },
                    ...filterOptions.nombre.map((nombre) => ({
                      label: nombre,
                      value: nombre,
                    })),
                  ]}
                  value={
                    filters.nombre
                      ? { label: filters.nombre, value: filters.nombre }
                      : { label: "Seleccionar cliente", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      nombre: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar cliente"
                />
              </div>

              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar asesor", value: "" },
                    ...filterOptions.asesor.map((asesor) => ({
                      label: asesor,
                      value: asesor,
                    })),
                  ]}
                  value={
                    filters.asesor
                      ? { label: filters.asesor, value: filters.asesor }
                      : { label: "Seleccionar asesor", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      asesor: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar asesor"
                />
              </div>

              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar teléfono", value: "" },
                    ...filterOptions.telefono.map((telefono) => ({
                      label: telefono,
                      value: telefono,
                    })),
                  ]}
                  value={
                    filters.telefono
                      ? { label: filters.telefono, value: filters.telefono }
                      : { label: "Seleccionar teléfono", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      telefono: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar telefono"
                />
              </div>

              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar condición", value: "" },
                    ...filterOptions.tipo_auto.map((tipo_auto) => ({
                      label: tipo_auto,
                      value: tipo_auto,
                    })),
                  ]}
                  value={
                    filters.tipo_auto
                      ? { label: filters.tipo_auto, value: filters.tipo_auto }
                      : { label: "Seleccionar condición", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      tipo_auto: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar condición"
                />
              </div>
            </div>

            <div className="mailbox-body" style={{ display: "block" }}>
              <div className="row">
                <div className="col-4">
                  <div
                    className="mailbox-sidebar"
                    style={{ height: "600px", maxWidth: "100%" }}
                  >
                    <PerfectScrollbar className="h-100">
                      <div className="mailbox-list">
                        {mailData && mailData.length > 0 ? (
                          mailData
                            .filter((registro) => {
                              if (isAdmin) return true; // Mostrar todo si es admin
                              return registro.id_usuario === userId; // Filtrar si no
                            })
                            .map((registro, index) => (
                              <div
                                key={index}
                                className="mailbox-list-item"
                                onClick={() => setSelectedMailData(registro)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="mailbox-message">
                                  <div className="mailbox-sender">
                                    <span className="mailbox-sender-name">
                                      {registro.nombre_completo ||
                                        construirNombreCompleto(registro) ||
                                        registro.nombre}
                                    </span>
                                    <span className="mailbox-time">
                                      {registro.fecha_creacion}
                                    </span>
                                  </div>
                                  <div className="mailbox-sender">
                                    <span className="mailbox-sender-name">
                                      {registro.marca_vehiculo}{" "}
                                      {registro.modelo_vehiculo} -{" "}
                                      {registro.ano_vehiculo}
                                    </span>
                                    <span className="mailbox-time">
                                      {registro.folio_venta}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))
                        ) : (
                          <div
                            className="mailbox-list-item"
                            style={{ minWidth: "360px" }}
                          >
                            No hay ventas
                          </div>
                        )}
                      </div>
                    </PerfectScrollbar>
                  </div>
                </div>

                <div className="col-8">
                  <div className="mailbox-content" style={{ height: "600px" }}>
                    <PerfectScrollbar className="h-100">
                      {selectedMailData ? (
                        <div className="mailbox-detail">
                          <div className="table-container">
                            <Card>
                              <CardHeader className="with-btn">
                                Ventas
                                <CardHeaderBtn />
                              </CardHeader>
                              <CardBody>
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-user"></i>
                                        Cliente
                                      </h5>
                                      <table className="table table-striped mb-0">
                                        <tbody>
                                          <tr>
                                            <td className="black-text">
                                              Nombre
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.nombre_completo ||
                                                construirNombreCompleto(
                                                  selectedMailData,
                                                ) ||
                                                selectedMailData.nombre}{" "}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Teléfono
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.telefono}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Correo
                                            </td>
                                            <td className="black-text">
                                              {
                                                selectedMailData.correo_electronico
                                              }
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Fecha de Registro
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.fecha_creacion}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>
                                </CardGroup>
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-car"></i>
                                        Vehículo
                                      </h5>
                                      <table className="table table-striped mb-0">
                                        <tbody>
                                          <tr>
                                            <td className="black-text">
                                              Marca
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.marca_vehiculo}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Modelo
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.modelo_vehiculo}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">Año</td>
                                            <td className="black-text">
                                              {selectedMailData.ano_vehiculo}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Versión
                                            </td>
                                            <td className="black-text">
                                              {
                                                selectedMailData.version_vehiculo
                                              }
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Condición
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.tipo_auto}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Precio Total
                                            </td>
                                            <td className="black-text">
                                              $
                                              {new Intl.NumberFormat("es-MX", {
                                                style: "decimal",
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                              }).format(
                                                selectedMailData.precio_vehiculo,
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Financiamiento Meses
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.meses_financiamiento
                                                ? `${selectedMailData.meses_financiamiento} meses`
                                                : "Sin meses"}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Enganche
                                            </td>
                                            <td className="black-text">
                                              $
                                              {new Intl.NumberFormat("es-MX", {
                                                style: "decimal",
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                              }).format(
                                                selectedMailData.enganche,
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>
                                </CardGroup>
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-box"></i>
                                        Planes
                                      </h5>
                                      <table className="table table-striped mb-0">
                                        <tbody>
                                          {selectedMailData &&
                                          selectedMailData.productos &&
                                          selectedMailData.productos.length >
                                            0 ? (
                                            selectedMailData.productos.map(
                                              (producto, index) => (
                                                <tr key={index}>
                                                  <td className="black-text">
                                                    {toTitleCase(
                                                      producto.title?.split(
                                                        " - ",
                                                      )[0] || "Sin título",
                                                    )}
                                                  </td>
                                                  <td className="black-text">
                                                    $
                                                    {new Intl.NumberFormat(
                                                      "es-MX",
                                                      {
                                                        style: "decimal",
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0,
                                                      },
                                                    ).format(producto.price)}
                                                  </td>
                                                </tr>
                                              ),
                                            )
                                          ) : (
                                            <tr>
                                              <td colSpan="3">
                                                No hay planes asociados
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>
                                </CardGroup>
                                {/* ===== Card: Entrevista ===== */}
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-clipboard-list"></i>
                                        Entrevista
                                      </h5>

                                      {(() => {
                                        const safeJsonParse = (v) => {
                                          if (!v) return null;
                                          if (typeof v === "object") return v;
                                          try {
                                            return JSON.parse(v);
                                          } catch (e) {
                                            return null;
                                          }
                                        };

                                        const get = (
                                          obj,
                                          path,
                                          fallback = "",
                                        ) => {
                                          if (!obj || !path) return fallback;
                                          return (
                                            path
                                              .split(".")
                                              .reduce((acc, key) => {
                                                if (
                                                  acc &&
                                                  Object.prototype.hasOwnProperty.call(
                                                    acc,
                                                    key,
                                                  )
                                                ) {
                                                  return acc[key];
                                                }
                                                return undefined;
                                              }, obj) ?? fallback
                                          );
                                        };

                                        const money = (v) => {
                                          const n = Number(
                                            String(v ?? "").replace(/,/g, ""),
                                          );
                                          if (!isFinite(n) || n === 0)
                                            return "";
                                          return `$${new Intl.NumberFormat(
                                            "es-MX",
                                            {
                                              style: "decimal",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            },
                                          ).format(Math.round(n))}`;
                                        };

                                        const pretty = (v) => {
                                          if (v === null || v === undefined)
                                            return "";
                                          if (Array.isArray(v))
                                            return v.filter(Boolean).join(", ");
                                          if (typeof v === "boolean")
                                            return v ? "Sí" : "No";

                                          if (typeof v === "string") {
                                            const s = v.trim();
                                            if (!s) return "";
                                            if (/^(si|sí)$/i.test(s))
                                              return "Sí";
                                            if (/^no$/i.test(s)) return "No";
                                            return s;
                                          }

                                          return String(v);
                                        };

                                        const entrevista = safeJsonParse(
                                          selectedMailData?.entrevista,
                                        );

                                        if (!entrevista) {
                                          return (
                                            <div className="text-muted">
                                              No hay entrevista asociada o el
                                              JSON es inválido.
                                            </div>
                                          );
                                        }

                                        const tipoAuto = (
                                          selectedMailData?.tipo_auto ||
                                          entrevista?.tipo_auto ||
                                          ""
                                        )
                                          .toString()
                                          .toLowerCase();

                                        const esSeminuevo =
                                          tipoAuto.includes("seminuevo");
                                        const esNuevo =
                                          tipoAuto.includes("nuevo") &&
                                          !tipoAuto.includes("seminuevo");

                                        const blocks = [
                                          {
                                            type: "section",
                                            title: "Entrevista consultiva",
                                          },
                                          {
                                            label:
                                              "¿La compra de su nuevo vehículo sería contado o crédito?",
                                            path: "pago_contado",
                                            format: (v) =>
                                              pretty(v) === "Sí"
                                                ? "Contado"
                                                : pretty(v) === "No"
                                                  ? "Crédito"
                                                  : pretty(v),
                                          },
                                          {
                                            label:
                                              "¿Acepta el seguro de auto dentro del proceso de cotización?",
                                            path: "acepta_seguro_auto",
                                            format: pretty,
                                          },

                                          // CONTADO
                                          {
                                            label:
                                              "¿Tiene definido el presupuesto que desea invertir?",
                                            path: "presupuesto_definido",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "Sí",
                                          },
                                          {
                                            label:
                                              "¿Está interesado en conocer opciones de protección o valor agregado para su vehículo?",
                                            path: "interes_proteccion",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "Sí",
                                          },

                                          // CRÉDITO
                                          {
                                            label:
                                              "¿Cuenta con historial de crédito?",
                                            path: "historial_credito",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },
                                          {
                                            label:
                                              "¿Cuánto de inversión inicial contempla?",
                                            custom: (obj) =>
                                              obj?.engancheEditable ||
                                              obj?.enganche ||
                                              obj?.inversion_inicial,
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },
                                          {
                                            label:
                                              "¿Qué mensualidad está buscando?",
                                            path: "mensualidad_buscada",
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },
                                          {
                                            label: "¿Comprueba ingresos?",
                                            path: "comprueba_ingresos",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },

                                          // CRÉDITO - SI COMPRUEBA
                                          {
                                            label:
                                              "¿Su actividad es asalariado o independiente?",
                                            path: "tipo_actividad",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label: "Actividad de la empresa",
                                            path: "actividad_empresa",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label:
                                              "Fecha de Ingreso o Inicio de actividades",
                                            path: "fecha_inicio_actividades",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label: "Nombre empresa o negocio",
                                            path: "nombre_empresa_negocio",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label:
                                              "¿Cuál es su ingreso mensual?",
                                            path: "ingreso_mensual",
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },

                                          // CRÉDITO - NO COMPRUEBA
                                          {
                                            label: "¿Cuál es su actividad?",
                                            path: "actividad_no_comprobable",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "No",
                                          },
                                          {
                                            label:
                                              "Fecha de Inicio de actividades",
                                            path: "fecha_inicio_actividades_no_comprobable",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "No",
                                          },
                                          {
                                            label:
                                              "¿Cuál es su ingreso mensual no comprobable?",
                                            path: "ingreso_mensual_no_comprobable",
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "No",
                                          },

                                          {
                                            type: "separator",
                                            title:
                                              "Identificación de necesidades de garantías",
                                          },
                                          {
                                            label:
                                              "¿Cómo son generalmente las calles por las que suele manejar?",
                                            path: "condiciones_calle_extra",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Ha extraviado alguna vez una llave de su auto o le preocupa el costo de una reposición?",
                                            path: "interes_llaves",
                                            format: pretty,
                                            showIf: () => esNuevo,
                                          },
                                          {
                                            label:
                                              "¿Ha tenido que dejar su auto en el taller por unos días tras un siniestro o reparación?",
                                            path: "ha_dejado_taller",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "Al adquirir un auto seminuevo, ¿le interesaría tener la tranquilidad de una garantía similar a la de un auto nuevo?",
                                            path: "garantia_seminuevo",
                                            format: pretty,
                                            showIf: () => esSeminuevo,
                                          },
                                          {
                                            label:
                                              "Para mayor privacidad y discreción al conducir, ¿le interesaría que su vehículo incluya polarizado que limite la visibilidad hacia el interior?",
                                            path: "desea_polarizado",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "Para mayor tranquilidad ante cualquier eventualidad, ¿le interesaría que su vehículo incluya un Kit de Emergencia completo desde la entrega?",
                                            path: "desea_kit_emergencia",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Le gustaría saber en tiempo real dónde se encuentra su auto todo el tiempo?",
                                            path: "tiempo_real",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Es importante para usted un respaldo que ayude a recuperar el auto en caso de robo?",
                                            path: "respaldo_auto",
                                            format: pretty,
                                          },

                                          {
                                            type: "separator",
                                            title: "Sabone",
                                          },
                                          {
                                            label:
                                              "¿Tiene vehículo actualmente?",
                                            path: "entrevista_nissan.tiene_vehiculo_actual",
                                            format: pretty,
                                          },
                                          {
                                            label: "¿Qué busca de su vehículo?",
                                            path: "entrevista_nissan.busca_en_vehiculo",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Quién manejaría el vehículo?",
                                            path: "entrevista_nissan.quien_manejara",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Qué uso le dará a su vehículo?",
                                            path: "entrevista_nissan.uso_vehiculo",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Qué factor considera importante para la compra de su vehículo?",
                                            path: "entrevista_nissan.factor_importante_compra",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Viaja en carretera regularmente?",
                                            path: "entrevista_nissan.viaja_carretera",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Para cuándo quiere realizar la compra del vehículo?",
                                            path: "entrevista_nissan.cuando_compra",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Usted tomaría la decisión de compra?",
                                            path: "entrevista_nissan.toma_decision_compra",
                                            format: pretty,
                                          },
                                          {
                                            label: "Motivantes de compra",
                                            path: "entrevista_nissan.motivantes_compra",
                                            format: pretty,
                                          },
                                        ];

                                        const rows = blocks
                                          .map((b, idx) => {
                                            if (
                                              b.type === "section" ||
                                              b.type === "separator"
                                            ) {
                                              return (
                                                <tr key={`sep-${idx}`}>
                                                  <td
                                                    colSpan={2}
                                                    className="fw-bold table-active"
                                                  >
                                                    {b.title}
                                                  </td>
                                                </tr>
                                              );
                                            }

                                            if (
                                              typeof b.showIf === "function" &&
                                              !b.showIf(entrevista)
                                            ) {
                                              return null;
                                            }

                                            const rawValue =
                                              typeof b.custom === "function"
                                                ? b.custom(entrevista)
                                                : get(entrevista, b.path, "");

                                            const value =
                                              (b.format
                                                ? b.format(rawValue)
                                                : pretty(rawValue)) || "";

                                            if (!value) return null;

                                            return (
                                              <tr key={`q-${idx}`}>
                                                <td className="black-text">
                                                  {b.label}
                                                </td>
                                                <td className="black-text">
                                                  {value}
                                                </td>
                                              </tr>
                                            );
                                          })
                                          .filter(Boolean);

                                        return (
                                          <table className="table table-striped mb-0">
                                            <tbody>
                                              {rows.length ? (
                                                rows
                                              ) : (
                                                <tr>
                                                  <td colSpan="2">
                                                    No hay respuestas para
                                                    mostrar
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        );
                                      })()}
                                    </CardBody>
                                  </Card>
                                </CardGroup>
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-car"></i>
                                        Seguro
                                      </h5>
                                      <table className="table table-striped mb-0">
                                        <tbody>
                                          <tr>
                                            <td className="black-text">
                                              Tipo Persona
                                            </td>
                                            <td className="black-text">
                                              Física
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">CP</td>
                                            <td className="black-text">
                                              03104
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">Uso</td>
                                            <td className="black-text">
                                              Particular
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Aseguradora
                                            </td>
                                            <td className="black-text">
                                              {seguro?.title || "-"}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Folio
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.folio_venta}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Vigencia
                                            </td>
                                            <td className="black-text">
                                              12 meses
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Prima total
                                            </td>
                                            <td className="black-text">
                                              $
                                              {seguro?.price
                                                ? new Intl.NumberFormat(
                                                    "es-MX",
                                                    {
                                                      style: "decimal",
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    },
                                                  ).format(seguro.price)
                                                : "-"}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>
                                </CardGroup>
                              </CardBody>
                            </Card>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="mailbox-detail-placeholder"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          Seleccione un cliente para ver los detalles
                        </div>
                      )}
                    </PerfectScrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VentasTotales;
